import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import { SchoolRepository } from "@/entities/school/domain/repository";
import type { GetSchoolResponseDto } from "@/entities/school/domain/dtos";

@singleton()
export default class SchoolRepositoryImpl implements SchoolRepository {
    constructor(@inject("HttpAdapter") private readonly httpAdaptor: HttpAdapter) {}

    public getSchools = async (keyword: string) => {
        let url = `/v1/schools`;

        if (keyword) {
            url += `?keyword=${keyword}`;
        }

        const response = await this.httpAdaptor.get<GetSchoolResponseDto>(url);

        return response;
    };
}
